export const storageConfig = {
  adminUserLogged: 'admin-user-logged',
  applicationIdSelected: 'application-id-selected',
  usersFilters: 'users-filters',
};
